module.exports = __webpack_public_path__ + "static/media/calculate-05.4d2c853f.svg";